export const createFunctionButton = {
  title: 'Create function',
  subtitle:
    "An empty function will be created, don't forget to populate its definition before trying out your agent.",
} as const;

export const RICH_TEXT_POPUP_COPY = {
  common: {
    noResults: 'No results found',
  },
  variantAttributeSection: {
    notInitialised: 'No variant attributes created yet, add one to get started',
    create: 'Create variant attribute',
  },
} as const;
